import FacultyProfile from "../../../pages/Faculty/login/viewProfile";

export const routePath = {
  login: "/login",
  studentwallet: "/student-wallet",
  studentwalletredemption: "/student-wallet-redemption",
  studentrewards: "/student-rewards",
  main: "/main",
  home: "/",
  studentdashboard: "/student-dashboard",
  scholarshipdiscovery: "/scholarship-discovery",
  scholarshipmatch: "/scholarship-match",
  sponsordashboard: "/sponsor-dashboard",
  studentredemptioncalog: "/student-redemption-catalog",
  sponsordashboardreport: "/sponsor-dashboard/report",
  studentrewardsredemption: "/student-rewards-redemption",
  studentprofile: "/student-profile",
  ViewStudentProfile:"/view-profile",
  sponsorprofile:"/sponsor-profile",
  ViewSponsorProfile:"/view-sponsor-profile",
  studentmessages:"/student-messages",
  sponsordashboardreport: "/sponsor-dashboard/report",
  monetizationads: "/monetization-ads",
sponsoraddashboard: "/sponsor-ad-dashboard",
sponsorapplication: "/sponsor-dashboard/sponsorapplication",
scholarshipPage: "/sponsor-dashboard/scholarshipPage",
addscholarshippage:"/sponsor-dashboard/addscholarshipPage",
  applications: "/application",
  addapplication: "/add-application",
  settings: "/settings",
  signup: "/signup",
  signupSponsor: "/sponsor/signup",
  signupInstitution: "/institution/signup",
  resetPassword: "/reset-password",
 scholarshipViewPage: "/scholarship/:id",
 loginSuccess:"/login-success",
 SponsoredScholarship: "/Sponsored-Scholarship",
 ForgotPassword:"/forgot-password",
 viewApplication:"/student/scholarship-application/:id/view",
 facultyDashboard:"/facultyDashboard",
 facultySignup:"/facultySignup",
 viewFacultyProfile:"/view-faculty-profile",
 facultyProfile:"/faculty-profile",
 InstitutionsPage:"/Institutions-list",
InstitutionViewPage: "/institution/view/:id",
  studentQueries: "/sponsor-dashboard/student-queries",  
 
};


    /*dashboard: "dashboard",
    billing:"billing",
    tableView:"tableView",
    user:"user",
    role:"role",
    table:"table",
    tableDetail:"tableDetail",
    discount:"discount",
    inventory:"inventory",
    inventorycost:"inventorycost",
    profile:"myprofile",
      resetpassword:"resetpassword",
       report:"report",*/
 
  
